// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__qswQF","loaderOuter":"PageOverlayLoader_loaderOuter__zHyy9"};